import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { FeedPathTag } from "@/components/FeedPathTag";
import { Cookie } from "lucide-react";

const BADGE_VARIANT_BY_STATUS = {
  COMPLETED: "default",
  ERROR: "destructive",
};

const FIELDS = [
  ["domain_id", "Domain ID", "Dealer.CookieManager.domain_id"],
  ["onetrust_domain", "OneTrust Domain", "Dealer.CookieManager.onetrust_domain"],
  ["message", "Message", "Dealer.CookieManager.message"],
  ["published_version", "Published Version", "Dealer.CookieManager.publishedVersion"],
];

/** OneTrust cookie-consent publish status, read-only — reflects Marvin/
 * OneTrust's own operational state, not dealer-editable data (see
 * CookieManagerStatus in models.py). */
export function CookieManagerCard({ dealer }) {
  const cookieManager = dealer.cookie_manager || {};
  const status = cookieManager.status || "";

  return (
    <Card className="mb-6 p-6" data-testid="cookie-manager-card">
      <div className="mb-4 flex items-center gap-2">
        <Cookie className="h-4 w-4 text-muted-foreground" />
        <h2 className="text-lg font-semibold">Cookie Manager</h2>
        {status && (
          <Badge variant={BADGE_VARIANT_BY_STATUS[status] || "secondary"} data-testid="cookie-manager-status-badge">
            {status}
          </Badge>
        )}
        <FeedPathTag path="Dealer.CookieManager.status" />
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        {FIELDS.map(([key, label, feedPath]) => (
          <div key={key}>
            <p className="data-label mb-1 flex items-center gap-1">
              {label}
              <FeedPathTag path={feedPath} />
            </p>
            <p className="text-sm" data-testid={`cookie-manager-${key}`}>
              {cookieManager[key] || "—"}
            </p>
          </div>
        ))}
      </div>
    </Card>
  );
}
